import z from 'zod';
import { modelsConfigVersion, User } from '../shared';
import { ModelsConfig } from '../tenant-configuration';

export const ModelsConfigResponse = z.object({
  version: modelsConfigVersion,
  modelsConfig: ModelsConfig,
  createdAt: z.iso.datetime({ offset: true }).pipe(z.coerce.date()).describe('Timestamp when the models configuration was created'),
  createdByUser: User.optional().describe('The user that created the models config'),
});
export type ModelsConfigResponseType = z.infer<typeof ModelsConfigResponse>;
